var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 15.6668H9.99967C13.333 15.6668 14.6663 14.3335 14.6663 11.0002V7.00016C14.6663 3.66683 13.333 2.3335 9.99967 2.3335H5.99967C2.66634 2.3335 1.33301 3.66683 1.33301 7.00016V11.0002C1.33301 14.3335 2.66634 15.6668 5.99967 15.6668Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70697 9L10.8534 6.85359C11.0489 6.6581 11.0489 6.34211 10.8534 6.14662C10.6579 5.95113 10.3419 5.95113 10.1464 6.14662L8 8.29303L5.85359 6.14662C5.6581 5.95113 5.34211 5.95113 5.14662 6.14662C4.95113 6.34211 4.95113 6.6581 5.14662 6.85359L7.29303 9L5.14662 11.1464C4.95113 11.3419 4.95113 11.6579 5.14662 11.8534C5.24411 11.9509 5.37211 11.9999 5.5001 11.9999C5.6281 11.9999 5.75609 11.9509 5.85359 11.8534L8 9.70697L10.1464 11.8534C10.2439 11.9509 10.3719 11.9999 10.4999 11.9999C10.6279 11.9999 10.7559 11.9509 10.8534 11.8534C11.0489 11.6579 11.0489 11.3419 10.8534 11.1464L8.70697 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossSquare);
export default __webpack_public_path__ + "static/media/cross-square.16e20a98b727afdbd622038f08eb21cd.svg";
export { ForwardRef as ReactComponent };